import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentService } from '@blk/cwp-ng-framework';
import { ChartType } from '@ddt-web/chart';
import { CellData, TabData } from '@ddt-web/data-service';
import { StringUtil } from '@ddt-web/generic-utils';
import * as get from 'lodash/get';

import { AteDcrConstants } from '../../constants';
import { InsightsChartHelper } from '../../helpers/insights-chart-helper';

@Component({
	selector: 'ate-doughnut-chart',
	templateUrl: './doughnut-chart.component.html',
	styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnChanges, OnInit {
	public categories: Array<CellData>;
	@Input() public sectionTitle: string;
	@Input() public targetCategory: string;
	@Input() public showSubHeaderContent: boolean;
	@Input() public data: TabData;
	@Input() public type: string;
	@Input('data-index') public dataIndex?: number;
	@Input() public selectedPortfolioIndex: number;
	@Input() public applicationTabPageMap: { string: string };

	public chartLink: string;
	public chartLinkText: string;
	public chartLinkUrl: string;
	public queryParams: any;

	public get chartType(): typeof ChartType {
		return ChartType;
	}

	constructor(private contentService: ContentService, private route: ActivatedRoute) { }

	public ngOnInit(): void {
		this.route.queryParams.subscribe(params => {
			this.queryParams = params;
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.data) {
			const helper = new InsightsChartHelper(this.data, this.selectedPortfolioIndex);
			this.categories = helper.initCategories();
			this.sectionTitle = helper.initHeaderInfo();
			this.initLink();
		}
	}

	private initLink(): void {
		this.chartLink = get(this.data, 'config.title.label.attributes["link"]');
		if (this.chartLink) {
			const linkTextKey = 'CHART_LINK_TEXT_';
			const chartLinkKey: string = StringUtil.replaceAll(this.chartLink, '.', '_').toUpperCase();
			this.chartLinkUrl = `/${this.applicationTabPageMap[chartLinkKey]}`;
			this.chartLinkText = this.contentService.get(linkTextKey + chartLinkKey.toUpperCase(), AteDcrConstants[linkTextKey + chartLinkKey].value);
		}
	}
}
